import "./intro.css";
import Stack from "@mui/material/Stack";
import Mobile_1 from "../../../assets/Mobile_1.svg";
import Mobile_2 from "../../../assets/Mobile_2.svg";
// import { useMediaQuery } from "react-responsive";

function Introduction() {
  // const Mobile = useMediaQuery({ maxWidth: 760 });
  // const Tab = useMediaQuery({ minWidth: 760 });

  return (
    <>
      <div className="container-fluid Intro mt-5">
        {/* {Tab && ( */}
          <div className="introduction mt-5">
            <div className="row mt-5">
              <div className="col-xl-6 col-md-6 intro mt-5 d-flex justify-content-center">
                <div className="intro_cnt">
                  <h1 className="intro_tit mt-5">
                    What is <span className="en">En</span>turf ?
                  </h1>
                  <p className="intro_defn mt-5 ">
                    Enturf is an AL powered live streaming,<br></br>recording
                    and turf booking<br></br> application.
                  </p>
                  <br></br>
                  <p className="intro_defn ">
                    It's a time travelling machine to travel<br></br> to the
                    past and relive the match.
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-md-6 d-flex justify-content-center mt-5">
                <div className="img">
                  <Stack direction="row" spacing={6}>
                    <img
                      src={Mobile_1}
                      alt="mobile_1"
                      className="mobile_1 img-fluid"
                    ></img>
                    <img
                      src={Mobile_2}
                      alt="mobile_2"
                      className="mobile_2 img-fluid"
                    ></img>
                  </Stack>
                  <div class="loader"></div>
                </div>
              </div>
            </div>
          </div>
         {/* )} */}
        {/* {Mobile && (
          <>
            <div className="introduction mt-5">
              <div className="row mt-5">
                <div className="col-xl-6 col-md-6 intro mt-5 d-flex justify-content-center">
                  <div className="intro_cnt">
                    <h1 className="intro_tit mt-5">
                      What is <span className="en">En</span>turf ?
                    </h1>
                  </div>
                </div>
                <div className="col-xl-6 col-md-6 d-flex justify-content-center mt-5">
                  <div className="img">
                    <Stack direction="row" spacing={6}>
                      <img
                        src={Mobile_1}
                        alt="mobile_1"
                        className="mobile_1 img-fluid"
                      ></img>
                      <img
                        src={Mobile_2}
                        alt="mobile_2"
                        className="mobile_2 img-fluid"
                      ></img>
                    </Stack>
                    <div class="loader"></div>
                  </div>
                </div>
                <div className="col-xl-6 col-md-6 d-flex justify-content-center">
                  <div>
                    <p className="intro_defn ">
                      Enturf is an AL powered live streaming,<br></br>recording
                      and turf booking<br></br> application.
                    </p>
                    <br></br>
                    <p className="intro_defn ">
                      It's a time travelling machine to travel<br></br> to the
                      past and relive the match.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </>
        )} */}
      </div>
    </>
  );
}

export default Introduction;
